import React from "react";
import { useSelector } from "react-redux";
import { useState, useEffect } from "react";
import useSnackbar from "../../../hooks/useSnackbar";
import { getTransactionDocRelatedRecords } from "../../../api/transaction-type";
import {
  salesOrderTransactionsTable,
  invoicePaymentsTable,
  salesOrderRelatedRecordTable,
  salesOrderRelatedRecordTransformationTable,
  invoicePayment,
  invoiceSupportCasesTable,
  invoiceTransformationTable,
} from "../../../config/grid-column-defs";
import AgGridPaginatedTable from "../../../components/AgGridPaginatedTable";

import { slugMap } from "../../../config/slug-config";
import { useParams } from "react-router-dom";
import {
  Box,
  Grid,
  Tabs,
  Tab,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  CircularProgress,
  Button,
} from "@mui/material";
import TabPanel from "../../../components/TabPanel";
import { makeStyles } from "@mui/styles";
import { getTransactionNotAvailable } from "../../../config/grid-value-formatters";

const useStyles = makeStyles((theme) => ({
  spacedTabs: {
    "& .MuiTab-root": {
      marginRight: theme.spacing(2), // Adjust the spacing as needed
    },
  },
}));
export default function QuoteRelatedRecords({ tabIndexP }) {
  const classes = useStyles();
  const snackbar = useSnackbar();
  const { data: user } = useSelector((state) => state.user);
  const params = useParams();
  const [loading, setLoading] = useState(false);
  const [tabIndex, setTabIndex] = useState(0);
  const pageDetail = slugMap[params.slug];
  const [tabIndexRelatedRecord, setTabIndexRelatedRecord] = useState(0);
  const [rowData, setRowData] = useState([]);

  async function getTransactionRelatedRecordsData(limit, offset) {
    setLoading(true);
    try {
      const { data } = await getTransactionDocRelatedRecords(user.token, {
        id: params.docNo,
        limit,
        offset,
      });
      setRowData(data.data.data);
      setLoading(false);
      return { rows: data.data.data, total: data.data.total, error: false };
    } catch (error) {
      console.log(error);
      setLoading(false);
      snackbar.showError("Error In Loading Data.");
      return { error: true };
    } finally {
      setLoading(false);
    }
  }

  return (
    <>
      <Box p={1}>
        <Tabs
          value={tabIndexRelatedRecord}
          // onChange={handleChange}
          onChange={(e, nv) => {
            setTabIndexRelatedRecord(nv);
          }}
          variant="scrollable"
          scrollButtons="auto"
          aria-label="scrollable auto tabs example"
          className={`${classes.spacedTabs} tabs-sub-bkg`}
          // className="tabs-sub-bkg"
        >
          <Tab label="Orders & Sales" />
          <Tab label="Support Cases" />
          <Tab label="Journals Of Billable Invoice" />
        </Tabs>
        <TabPanel value={tabIndexRelatedRecord} index={0}>
        <Box className="viewDetailsBox" display="flex">
            <Button className="backBtn" style={{margin:"2px"}} onClick={() => {}}>
              Print
            </Button>
          </Box>
          <AgGridPaginatedTable
            getTableRows={getTransactionRelatedRecordsData}
            columns={invoicePayment}
            perPage={20}
            refreshCounter={0}
          />
        </TabPanel>
        <TabPanel value={tabIndexRelatedRecord} index={1}>
          <AgGridPaginatedTable
            getTableRows={getTransactionNotAvailable}
            columns={invoiceSupportCasesTable}
            refreshCounter={0}
            perPage={5}
          />
        </TabPanel>
        <TabPanel value={tabIndexRelatedRecord} index={2}>
          <AgGridPaginatedTable
            getTableRows={getTransactionNotAvailable}
            columns={invoiceTransformationTable}
            refreshCounter={0}
          />
        </TabPanel>
      </Box>
    </>
  );
}
